
import io from 'socket.io-client';
const siteUrl =  process.env.CLOUD_CFO_URL || "//localhost:3008/"
const protocol = process.env.PROTOCOL || 'http:'
const uri = `${protocol}${siteUrl}` 
const socket = io(uri, {
    transports: ['websocket'],
    path:'/socket.io/',
    secure:true,
    // forceNew:true
});

export default function reducer(state={
        container : socket
    },action){
        return state;
}